import { authAxios } from "../../axios/axios";

import * as apis from "../../apis";
import * as errors from "../../errors"

import { sendAction } from "../../helpers";

import { notifyError } from "../../toast-notifications";
import { getTablesSuccess, getTables, getTableLinks } from "./tables";
import { getReservationsSuccess, getReservations } from "./reservations";
import { getZones, getZonesSuccess } from "./zones";
import { GET_NEW_FEEDBACKS_SUCCESS } from "./feedbacks";
import queryClient from "@/queries/queryClient";
import { RESERVATIONS_COUNTS_KEY } from "@/queries/reservations/hooks";
import { CHAT_THREADS_KEY } from "@/features/messaging/queries/threads/hooks";

export const AUTOREFRESH_REQUEST = "AUTOREFRESH_REQUEST";
export const AUTOREFRESH_SUCCESS = "AUTOREFRESH_SUCCESS";
export const AUTOREFRESH_ERROR = "AUTOREFRESH_ERROR";

const autoRefreshRequest = () => {
    return {
        type: AUTOREFRESH_REQUEST,
    }
};

const autoRefreshSuccess = () => {
    return {
        type: AUTOREFRESH_SUCCESS,
    }
};

const autoRefreshError = (error) => {
    return {
        type: AUTOREFRESH_ERROR,
        error,
    }
};

export const autoRefresh = () => {
    return (dispatch, getState) => {
        const hasFeedbacksModule = getState().settingsReducer.restaurantSettings.modules.feedbacks_enabled;

        dispatch(autoRefreshRequest());

        const requestsApis = [
            apis.GET_RESERVATIONS_API,
            apis.GET_TABLES_API,
            apis.ZONES_API,
        ];

        if (hasFeedbacksModule)
            requestsApis.push(apis.GET_NEW_FEEDBACKS_API);

        const requests = requestsApis.map(api => authAxios.get(api));

        Promise.all(requests)
            .then((responses) => {
                queryClient.invalidateQueries(RESERVATIONS_COUNTS_KEY);
                responses = responses.map(v => v.data);
                dispatch(getReservationsSuccess(responses[0]));
                dispatch(getTablesSuccess(responses[1]));
                dispatch(getZonesSuccess(responses[2]));

                if (hasFeedbacksModule)
                    dispatch(sendAction(GET_NEW_FEEDBACKS_SUCCESS, { data: responses[3] }));

                dispatch(autoRefreshSuccess());
            })
            .catch((err) => {
                dispatch(autoRefreshError(errors.REFRESH_ERROR));
                notifyError(errors.REFRESH_ERROR);
            });
    };
}

export const basicRefresh = () => {
    return dispatch => {
        queryClient.invalidateQueries(RESERVATIONS_COUNTS_KEY);
        queryClient.invalidateQueries(CHAT_THREADS_KEY);
        // dispatch(getCustomers());
        dispatch(getTables());
        dispatch(getReservations());
    }
}

export const zoneRefresh = () => {
    return dispatch => {
        dispatch(getTables());
        dispatch(getZones());
        dispatch(getTableLinks());
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/autoRefresh.js